<script setup lang="ts">
import { computed } from 'vue'

import { useOrgSortTagStyle } from '@/composables/useOrgSortTagStyle'

import * as aggr from '@/api-generator/aggr'
import { ORG_SORT_TAG_STYLE_CONFIG, ORG_SORT_TAG_VARIANTS, type OrgSortTagVariant } from '@/constant/client/orgSortTag'
import appStore from '@/stores'

interface Props {
  orgTagId?: number | null
  variant?: OrgSortTagVariant
  /** 是否為選中狀態（僅在 tag variant 下有效） */
  selected?: boolean
}

const { orgTagId, variant = ORG_SORT_TAG_VARIANTS.DEFAULT, selected = false } = defineProps<Props>()

const orgSortTagStore = appStore.useOrgSortTagStore

const { getOrgSortTagStyle } = useOrgSortTagStyle()

const currentTag = computed(() => {
  if (!orgTagId || !orgSortTagStore.orgSortTags) {
    return null
  }
  return orgSortTagStore.orgSortTags.find((tag: aggr.FECompanyQueryOrganizationTagsRs) => tag.orgTagId === orgTagId)
})

const tagStyle = computed(() => {
  if (!orgTagId) {
    return null
  }
  return getOrgSortTagStyle({ orgTagId })
})

// ============ 樣式設定 ============
const config = computed(() => ORG_SORT_TAG_STYLE_CONFIG[variant])

const containerClass = computed(() => {
  const containerConfig = config.value.container

  if (variant === ORG_SORT_TAG_VARIANTS.TAG && 'selected' in containerConfig) {
    return `${containerConfig.base} ${selected ? containerConfig.selected : containerConfig.unselected}`
  }

  return containerConfig.base
})

const contentClass = computed(() => config.value.content.base)
const dotClass = computed(() => config.value.dot.base)
const textClass = computed(() => config.value.text.base)
</script>

<template>
  <div v-if="currentTag && tagStyle?.style" v-bind="$attrs" :class="containerClass">
    <div :class="contentClass">
      <div :class="dotClass" :style="tagStyle.style"></div>
      <div :class="[textClass, 'truncate']">
        {{ currentTag.tagName }}
      </div>
    </div>
  </div>
</template>

<style scoped></style>
